import React, { useEffect } from 'react';
import {
  Paper,
  Typography,
  Grid,
  TextField,
  Autocomplete
} from '@mui/material';

/**
 * Supplier Information Component for Purchase Returns
 */
const SupplierInformation = ({
  purchaseReturn,
  controlStyle,
  suppliers = [],
  onPurchaseReturnChange
}) => {
  useEffect(() => {
    console.log('SupplierInformation: purchaseReturn changed', purchaseReturn);
    if (purchaseReturn && purchaseReturn.supplier) {
      console.log('SupplierInformation: supplier data received', purchaseReturn.supplier);
    }
  }, [purchaseReturn]);

  const supplier = purchaseReturn?.supplier || {};

  const formatAddress = (addr) => {
    if (!addr) return '';
    if (typeof addr === 'string') return addr;
    
    if (typeof addr === 'object') {
      const parts = [
        addr.street,
        addr.shortAddress,
        addr.city,
        addr.state,
        addr.country,
        addr.postalCode
      ].filter(part => part && String(part).trim() !== '');
      return parts.join(', ');
    }
    
    return String(addr);
  };

  const displayAddress = formatAddress(supplier.address || supplier.customerAddress);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 0.5,
        mb: 0.5,
        borderRadius: '4px',
        boxShadow: 'none',
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.02)',
        },
      }}
    >
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 0.5, fontSize: '0.875rem' }}>
        Supplier Information
      </Typography>
      <Grid container spacing={0.5}>
        <Grid item xs={12}>
          <Autocomplete
            options={suppliers}
            getOptionLabel={(option) => option.name || option.customerName || ''}
            value={
              suppliers.find(s => s.id === supplier.id || s.name === (supplier.name || supplier.customerName)) || null
            }
            onChange={(event, newValue) => {
              if (onPurchaseReturnChange) {
                onPurchaseReturnChange(prev => ({
                  ...prev,
                  supplier: newValue || null
                }));
              }
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id || option.name === value.name}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Supplier Name"
                required
                fullWidth
                margin="dense"
                size="small"
                sx={controlStyle}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          {supplier.vat || supplier.vatNumber ? (
            <TextField
              label="VAT Number"
              value={supplier.vat || supplier.vatNumber || ''}
              fullWidth
              margin="dense"
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={controlStyle}
            />
          ) : (
            <TextField
              label="Phone Number"
              value={supplier.phone || supplier.customerPhone || ''}
              fullWidth
              margin="dense"
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={controlStyle}
            />
          )}
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Address"
            value={displayAddress}
            fullWidth
            multiline
            rows={2.5}
            margin="dense"
            size="small"
            InputProps={{
              readOnly: true,
            }}
            sx={{
              ...controlStyle,
              '& .MuiOutlinedInput-root': {
                minHeight: 70,
                borderRadius: 0
              }
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default SupplierInformation;
